import { getAppState } from "../state";
import { i18n } from "./../services/i18nService";
import { getSuperParentAddOnNameForSVOD } from "./tvodUtils";
import { checkForUmanagedOrNonChangeableMop } from "../services/billingService";
import { getParentAddOn } from "./mobileLiteUtils";

export const CREDIT_CARD = "CREDIT_CARD";

export function getPackageTimeUnit(unit, duration) {
  if (duration === 1) {
    return TranslationTextforBillingCycle(`${unit}${duration}`);
  }
  if (unit === "month" && duration === 12) {
    return TranslationTextforBillingCycle(`${unit}${duration}`, duration);
  }
  return TranslationTextforBillingCycle(`${unit}`, duration);
}
export function TranslationTextforBillingCycle(templatePattern, packageDuration) {
  return packageDuration
    ? i18n.get(`pages.brands.billingCyle.${templatePattern}`, packageDuration)
    : i18n.get(`pages.brands.billingCyle.${templatePattern}`);
}

export function isParentSubscriptionActive(addons, addOnName) {
  const parentSubscriptionName = getSuperParentAddOnNameForSVOD(addons, addOnName);
  return isSubscriptionActive(addons, parentSubscriptionName);
}

export function isSubscriptionActive(addons, addOnName) {
  const activeSubscription = addons.find(addon => addon.name === addOnName && addon.status.toLowerCase() === "active");
  if (activeSubscription && activeSubscription.name) return activeSubscription;
  return null;
}

export function getGrandParentAddOnName(addons, addOnName) {
  const parentAddOn = getParentAddOn(addOnName);
  const isParentActive = parentAddOn && isSubscriptionActive(addons, parentAddOn.name);
  if (!isParentActive) {
    return addOnName;
  }
  return getGrandParentAddOnName(addons, parentAddOn.name);
}

export function getAddOnByName(addOnName) {
  const addOnsList = getAppState().subscriptions?.filter(data => data?.name === addOnName) || [];
  if (addOnsList?.length > 0) {
    return addOnsList[0];
  }
  return null;
}

export async function isNonChangeableMop() {
  const isNonChangeable = await checkForUmanagedOrNonChangeableMop.call(this, true);
  return isNonChangeable;
}

export function getPaymentPlansConfiguration(subscription) {
  const mop =
    subscription && subscription.paymentMethods.find(paymentMethod => paymentMethod.paymentType === CREDIT_CARD);
  const paymentPlansConfig = (mop && mop.configuration) || [];
  return paymentPlansConfig;
}
